import { Component, OnInit, Input } from '@angular/core';
import { CallAPIService } from '../../../services/call-api.service';
import { BehaviorSubject } from 'rxjs';
import { PostOfficeInfo } from '../../../interfaces/post-office-info.interface';
import { WhatToClear } from '../../../interfaces/what-to-clear.interface';



@Component({
  selector: 'response-address-loader',
  templateUrl: './response-address-loader.component.html',
  styleUrls: ['./response-address-loader.component.sass']
})
export class ResponseAddressLoaderComponent implements OnInit {

  @Input('clear') clear: BehaviorSubject<any>;
  @Input('addressResponseReadySubject') addressResponseReadySubject: BehaviorSubject<any>;


  public adressObject: any = {};
  public postOffice: any = {};
  public isResponseReady: boolean = false;
  public isResponseError: boolean = false;
  public schedule;

  constructor(
    private API: CallAPIService,
  ) {

    //this.response.streets = undefined
    this.API.getObservableStreetsInfo().subscribe(response => {
      this.isResponseReady = false;
      if (response != undefined) {

        this.adressObject = response;
        this.isResponseReady = true;
        if (this.isEmptyObject(this.postOffice)) {
          //this.isResponseError = true ;

        }

      }

    })

    this.API.getObservablePostOfficeInfo().subscribe((response: Array<PostOfficeInfo>) => {

      if (response != undefined && !this.isEmptyObject(response)) {


        let selectedOffice: PostOfficeInfo;

        if (Array.isArray(response) && response.length == 1 && this.isEmptyObject(response[0])) {
          if (this.isResponseReady)
            this.isResponseError = true;
          return;
        }

        let centralPostOffice = response.find((office: PostOfficeInfo) => {
          return office.TYPE_ACRONYM.trim().toLocaleLowerCase().includes("цвпз");
        });

        let cityPostOffice = response.find((office: PostOfficeInfo) => {
          return office.TYPE_ACRONYM.trim().toLocaleLowerCase().includes("мвпз");
        });

        let villagePostOffice = response.find((office: PostOfficeInfo) => {
          return office.TYPE_ACRONYM.trim().toLocaleLowerCase().includes("свпз");
        });

        if (centralPostOffice != undefined) {
          selectedOffice = centralPostOffice;
        } else if (cityPostOffice != undefined) {
          selectedOffice = cityPostOffice;
        } else if (villagePostOffice != undefined) {
          selectedOffice = villagePostOffice;
        } else {
          selectedOffice = response[0];
        }


        if (response != undefined && !this.isEmptyObject(selectedOffice)) {

          this.schedule = response[0].scadule;
          // Индекс, название населенного пункта, адрес отделения, тип отделения, обслуживает или нет (этот параметр определяет LOCK_UA?)

          this.postOffice['postOfficeFullName'] = selectedOffice.PO_LONG;

          this.postOffice['postIndex'] = selectedOffice.POSTINDEX;
          this.postOffice['postCode'] = selectedOffice.POSTCODE;
          this.postOffice['cityName'] = selectedOffice.CITYTYPE_UA + " " + selectedOffice.CITY_UA;
          this.postOffice['postOfficeAddress'] = selectedOffice.ADDRESS;
          // this.postOffice['postOfficeType'] = selectedOffice.TYPE_SHORT;
          this.postOffice['postOfficeType'] =
            selectedOffice.IS_POSHTOMAT == '1'
              ? selectedOffice.TYPE_LONG
              : selectedOffice.TYPE_SHORT;
          this.postOffice['postOfficeLock'] = selectedOffice.LOCK_UA;
          // this.postOffice['officeName'] = selectedOffice.PO_SHORT;
          this.postOffice['officeName'] =
            selectedOffice.IS_POSHTOMAT == '1'
              ? selectedOffice.PO_SHORT?.replace('П-т', 'Поштомат')
              : selectedOffice.PO_SHORT;
          this.postOffice['scadule'] = selectedOffice.scadule;
          this.postOffice['officeFullAddress'] = selectedOffice.SHORTCITYTYPE_UA + " " + selectedOffice.CITY_UA + ", " + selectedOffice.DISTRICT_UA + " р-н, " + selectedOffice.REGION_UA + " обл.";
          this.postOffice['typeShirt'] = selectedOffice.TYPE_ACRONYM;
          this.postOffice['isNoDistrict'] = selectedOffice.IS_NODISTRICT;
          this.postOffice['NOTES_UA'] = selectedOffice.NOTES_UA;
          this.postOffice['PDAddress'] = selectedOffice.PDCITYTYPE_UA + ' ' + selectedOffice.PDCITY_UA;
          this.postOffice['Avalible'] = selectedOffice.AVALIBLE;
          this.postOffice['IS_PUDO'] = selectedOffice.IS_PUDO;
          this.postOffice['ADDRESS_NOTE'] = selectedOffice.ADDRESS_NOTE;

          if (this.addressResponseReadySubject)
            this.addressResponseReadySubject.next(selectedOffice);

          this.isResponseError = false;
          //if(  ( response && response.length == 0 )  ){ // response == undefined ||
          //  this.isResponseError = true ;
          //}

        } else {
          if (response != undefined)
            this.isResponseError = true;
        }

      } // if not undefined

    })
  }

  ngOnInit() {

    this.clear.subscribe((cl: WhatToClear) => {

      if (cl && cl.toClearResponse) {
        this.clearResponseData();
      }
    });


  }

  isString(a) {
    return typeof a == 'string'
  }

  isEmptyObject(obj: object) {
    return Object.keys(obj).length === 0 && obj.constructor === Object
  }

  clearResponseData() {

    this.isResponseReady = false;
    this.isResponseError = false;
    this.adressObject = {};
    this.postOffice = {};
  }


  isContainsType(name: string): boolean {
    name = name.toLocaleLowerCase();
    let result = name.includes('пвпз') || name.includes('мвпз') || name.includes('свпз') || name.includes('впз') || false;
    return result
  }

  isSVPZ(acronym: string): boolean {
    if (!acronym) return false
    return acronym.toLocaleLowerCase().trim() == 'свпз'.trim()
  }

  isPVPZ(acronym: string): boolean {
    if (!acronym) return false
    return acronym.toLocaleLowerCase().trim() == 'пвпз'.trim()
  }



}
